var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isExpired && !_vm.isBeforeStart
    ? _c(
        "div",
        {
          staticClass: "countdown-container",
          class: { clickable: this.targetUrl },
          on: { click: _vm.navigateToUrl }
        },
        [
          _c("div", { staticClass: "countdown-body", style: _vm.bodyStyle }, [
            _c("div", { staticClass: "countdown-header" }, [
              _c("h2", { domProps: { innerHTML: _vm._s(_vm.headerText) } }),
              _vm._v(" "),
              _vm.logoSrc
                ? _c("img", {
                    staticClass: "logo-icon",
                    attrs: { src: _vm.logoSrc, alt: "Logo" }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "countdown-display" }, [
              _c(
                "div",
                {
                  staticClass: "timer-segments",
                  style: _vm.timerSegmentsStyle
                },
                [
                  _c("div", { staticClass: "time-segment" }, [
                    _c(
                      "span",
                      {
                        staticClass: "digit",
                        style: { color: _vm.TimerTextColor },
                        attrs: { id: "days" }
                      },
                      [_vm._v(_vm._s(_vm.days))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "label",
                        style: { color: _vm.TimerTextColor }
                      },
                      [_vm._v("DAYS")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "colon digit",
                      style: { color: _vm.TimerTextColor }
                    },
                    [_vm._v(":")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "time-segment" }, [
                    _c(
                      "span",
                      {
                        staticClass: "digit",
                        style: { color: _vm.TimerTextColor },
                        attrs: { id: "hours" }
                      },
                      [_vm._v(_vm._s(_vm.hours))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "label",
                        style: { color: _vm.TimerTextColor }
                      },
                      [_vm._v("HRS")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "colon digit",
                      style: { color: _vm.TimerTextColor }
                    },
                    [_vm._v(":")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "time-segment" }, [
                    _c(
                      "span",
                      {
                        staticClass: "digit",
                        style: { color: _vm.TimerTextColor },
                        attrs: { id: "minutes" }
                      },
                      [_vm._v(_vm._s(_vm.minutes))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "label",
                        style: { color: _vm.TimerTextColor }
                      },
                      [_vm._v("MINS")]
                    )
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "countdown-footer",
              style: { backgroundColor: _vm.footerColor }
            },
            [
              _c("span", {
                staticClass: "artifakt-font",
                domProps: { innerHTML: _vm._s(_vm.footerText) }
              })
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e1717da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e1717da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/CountdownTimer.vue
// module id = null
// module chunks = 